import { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface SummaryExtendedItemDef {
  title: string
  value: ReactNode
  icon: ReactNode
  subtitle?: string
  subtitleClassName?: string
  valueClassName?: string
}

interface SummaryExtendedProps {
  items: SummaryExtendedItemDef[]
}

export const SummaryExtendedItem = ({
  title,
  value,
  icon: Icon,
  subtitle,
  subtitleClassName = 'text-xs text-muted-foreground mt-1',
  valueClassName,
}: SummaryExtendedItemDef) => (
  <Card>
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-sm font-medium">{title}</CardTitle>
      {Icon}
    </CardHeader>
    <CardContent>
      <div className={`text-2xl font-bold ${valueClassName || ''}`}>{value}</div>
      {subtitle && <p className={subtitleClassName}>{subtitle}</p>}
    </CardContent>
  </Card>
)

export const SummaryExtended = ({ items }: SummaryExtendedProps) => {
  const colClass = items.length === 1
    ? 'md:grid-cols-1'
    : items.length === 2
      ? 'md:grid-cols-2'
      : items.length === 3
        ? 'md:grid-cols-2 lg:grid-cols-3'
        : 'md:grid-cols-2 lg:grid-cols-4'

  return (
    <div className={`grid gap-4 ${colClass}`}>
      {items.map((item, index) => (
        <SummaryExtendedItem key={index} {...item} />
      ))}
    </div>
  )
}
